import { addMessages } from '@hana/i18n';

// Khoá chuỗi cq.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cq.1': "Theo người nhập · tháng 10",
  'cq.2': "Người",
  'cq.3': "Ảnh nộp",
  'cq.4': "Đạt",
  'cq.5': "Trả về",
  'cq.6': "Trễ",
  'cq.7': "Cờ",
  'cq.8': "Chặn tạm ứng",
  'cq.9': "Bị chặn / trả về gần đây",
  'cq.10': "Hạn nhập: trong ngày.",
});
addMessages('en', {
  'cq.1': "By submitter · October",
  'cq.2': "Person",
  'cq.3': "Photos",
  'cq.4': "Passed",
  'cq.5': "Returned",
  'cq.6': "Late",
  'cq.7': "Flags",
  'cq.8': "Advance blocked",
  'cq.9': "Recently blocked / returned",
  'cq.10': "Entry deadline: same day.",
});
